import { Injectable } from '@angular/core';
import { IShift } from '../../../interfaces/shift';
import { NotificationHandlerService } from 'projects/common/src/app/services';
import { ParameterAsync } from 'projects/common/src/app/classes';
import { CommunicationService } from 'src/app/services/communication';
import { filter } from 'rxjs/operators';
import { IRawApplication } from 'projects/common/src/app/interfaces/remote-models/raw-application';
import { Observable } from 'rxjs';
import { UserDataService } from '../user-data/user-data.service';
import { IMachineContext } from 'projects/common/src/app/interfaces/machine-context';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class ShiftCollectionService extends ParameterAsync<IShift[]> {
  private currentApplication: number;
  private baseUrl: string;

  constructor(
    protected http: CommunicationService,
    protected notificationService: NotificationHandlerService,
    protected userData: UserDataService,
    protected urlBuilderService: UrlBuilderService,
  ) {
    super(http, notificationService);
    this.name = 'shift-collection';
    this.baseUrl = this.urlBuilderService.serverBasePath;
    this.urlEndpoint = `${this.baseUrl}/shift/getshiftbycompany`;
  }

  public startWhen(source: Observable<IRawApplication>): void {
    this.subscription = source.pipe(filter((data) => !!data)).subscribe((data) => {
      this.alreadyStarted = true;
      this.currentApplication = data.menuId;
      this.init();
    });
  }

  protected getArgument(): { [key: string]: any } {
    const machineContext = JSON.parse(sessionStorage.getItem('machine-context')) as IMachineContext;

    // verify if is null or undefined
    if (!machineContext?.machineTypeId) {
      const machineCollection = JSON.parse(sessionStorage.getItem('machineCollection'));
      if (Array.isArray(machineCollection)) {
        const matchingMachine = machineCollection.find((machine) => machine.name?.toLowerCase() === machineContext.name?.toLowerCase());
        if (matchingMachine) {
          machineContext.machineTypeId = matchingMachine.machineTypeId;
          sessionStorage.setItem('machine-context', JSON.stringify(machineContext));
        }
      }
    }
    return {
      companyId: this.userData.get().company.id,
      machineTypeId: machineContext.machineTypeId,
    };
  }
}
